import { render, staticRenderFns } from "./FormVerticalRadio.vue?vue&type=template&id=577e5fd3&scoped=true"
import script from "./FormVerticalRadio.vue?vue&type=script&lang=ts"
export * from "./FormVerticalRadio.vue?vue&type=script&lang=ts"
import style0 from "./FormVerticalRadio.vue?vue&type=style&index=0&id=577e5fd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577e5fd3",
  null
  
)

export default component.exports